<template>
	<div>
		<el-table :data="tableData" show-summary :summary-method="getSummaries" row-class-name="getRowClassName">
			<el-table-column label="Code" width="100">
				<template slot-scope="scope">
					<p v-if="scope.row.aks_rep_itm_detail_is_manual != 1" class="top-line text-break">{{
						scope.row.aks_rep_itm_detail_org_no }}</p>
					<!-- <el-input v-else v-model="scope.row.aks_rep_itm_detail_code"></el-input> -->
				</template>
			</el-table-column>
			<el-table-column label="Org" width="100">
				<template slot-scope="scope">
					<p v-if="scope.row.aks_rep_itm_detail_is_manual != 1" class="top-line text-break">{{
						scope.row.aks_rep_itm_detail_org_name }}</p>
					<!-- <el-input v-else v-model="scope.row.aks_rep_itm_detail_org_name"></el-input> -->
				</template>
			</el-table-column>
			
			<el-table-column label="Desc" width="280">
				<template slot-scope="scope">
					<p v-if="scope.row.aks_rep_itm_detail_is_manual != 1" class="top-line text-break">{{
						scope.row.aks_rep_itm_detail_type }} <br/>{{ scope.row.aks_rep_itm_detail_begin +' - '+scope.row.aks_rep_itm_detail_end }}</p>
					<el-input v-else v-model="scope.row.aks_rep_itm_detail_description" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column label="Remaining Month" width="280">
				<template slot-scope="scope">
					<p v-if="scope.row.aks_rep_itm_detail_is_manual != 1" class="top-line text-break">{{  scope.row.aks_rep_itm_detail_remain_month }}</p>
					<el-input v-else v-model="scope.row.aks_rep_itm_detail_remain_month" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="aks_rep_itm_detail_credit_limit" sortable width="150px" :formatter="formatCurrency"
				label="Credit Limit">
				<template slot-scope="scope">
					<p v-if="scope.row.aks_rep_itm_detail_is_manual != 1" class="top-line text-break">{{
						scope.row.aks_rep_itm_detail_credit_limit }}</p>
					<el-input v-else v-model="scope.row.aks_rep_itm_detail_credit_limit" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="aks_rep_itm_detail_current_outstanding" sortable width="170px" :formatter="formatCurrency"
				label="Current Outstanding">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<p v-if="scope.row.aks_rep_itm_detail_is_manual != 1" class="top-line text-break">{{
						scope.row.aks_rep_itm_detail_current_outstanding }}</p>
					<el-input v-else v-model="scope.row.aks_rep_itm_detail_current_outstanding" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="aks_rep_itm_detail_current_instalment" sortable label="Current Installment" width="140">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.aks_rep_itm_detail_current_instalment" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="aks_rep_itm_detail_special_settlement" sortable label="Special Settlement" width="140">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input :disabled="(_gHlp.checkAccess(['role_telemarketing'])) || scope.row.aks_rep_itm_detail_is_consolidate"
						v-model="scope.row.aks_rep_itm_detail_special_settlement"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="aks_rep_itm_detail_consolidate_settlement" width="190" label="Consolidate Settlement">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input :disabled="(_gHlp.checkAccess(['role_telemarketing'])) || scope.row.aks_rep_itm_detail_is_consolidate" v-model="scope.row.aks_rep_itm_detail_consolidate_settlement"></el-input>
				</template>
			</el-table-column>
			<el-table-column width="auto">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.aks_rep_itm_detail_is_consolidate" active-color="#13ce66" @change="setConsolidate(scope.$index,scope.row)" :disabled="(_gHlp.checkAccess(['role_telemarketing']))"></el-switch>
				</template>
			</el-table-column>
			<el-table-column label="New Installment" prop="aks_rep_itm_detail_new_instalment" sortable width="160px">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.aks_rep_itm_detail_new_instalment" :disabled="(_gHlp.checkAccess(['role_telemarketing']))"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="Action">
				<template slot-scope="scope">
						<el-button 
								@click="deleteItem(scope.row.aks_rep_itm_detail_id,scope.$index)"
								type="danger" 
								icon="el-icon-close"
								size="mini" 
								circle
								class="p-0"
								v-if="scope.row.aks_rep_itm_detail_is_manual == 1"
                :disabled="(_gHlp.checkAccess(['role_telemarketing']))"
						></el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-button type="text" @click="addItem" v-if="(!_gHlp.checkAccess(['role_telemarketing']))"
    >+ Add Angkasa</el-button>
		<div class="mt-3">
			<b-row class="d-flex justify-content-center">
				<b-col cols="6" md="3">
					<el-button class="bg-primary text-white w-100" @click="saveTable" :loading="is_loading" v-if="(!_gHlp.checkAccess(['role_telemarketing']))"
          >Save
					</el-button>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import { Button, Table, TableColumn, Input, Switch } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'

export default {
	props: ['commitments', 'tables'],
	components: {
		[Switch.name]: Switch,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Input.name]: Input
	},
	data() {
		return {
			current_credit_report_id:null,
			current_customer_id:null,
			is_loading: false,
			tableData: [],
			deleteIds:[]
		}
	},
	computed: {
		...mapState(useCustomerStore, ['current_customer', 'current_commitment']),
	},
	watch: {
		current_commitment: {
			handler(newVal) {
				this.setTable()
			}
		},
		current_customer: {
			handler(newVal) {
				if(newVal){
					this.current_customer_id = newVal.customer_id;
				}
			}
		}
	},
	created() {
		this.setTable()
	},
	methods: {
		...mapActions(useCreditReportStore, ['saveAllAngkasaItems','deleteAngkasaItems']),
		setTable() {
			this.deleteIds = [];
			this.tableData = [];
			if (!_gHlp.isEmpty(this.current_commitment)) {
				this.current_credit_report_id = this.current_commitment.credit_report_id;
				const creditSummary = this.current_commitment;
				if (!_gHlp.isEmpty(creditSummary) && !_gHlp.isEmpty(creditSummary.credit_report_summary.angkasa_reports)) {
					const angkasa = creditSummary.credit_report_summary.angkasa_reports;
					
					this.tableData = angkasa.flatMap(obj => {
						return Object.values(obj.aks_rep_items).flatMap(innerArr => {
							return innerArr.aks_rep_itm_details.map((x => {

								//MODIF FOR SWITCH ELEMENT
								x.aks_rep_itm_detail_is_consolidate = x.aks_rep_itm_detail_is_consolidate == 1 ? true : false;
								x.aks_rep_itm_detail_org_no = innerArr.aks_rep_itm_org_no;
								x.aks_rep_itm_detail_org_name = innerArr.aks_rep_itm_org_name;
								return x;
							}))
						})
					});
				}
			}
		},
		addItem() {
			this.tableData.push({
				aks_rep_itm_detail_is_manual: 1,
				aks_rep_itm_detail_is_consolidate: false,
				aks_rep_itm_detail_application_code: '',
				aks_rep_itm_detail_begin: '',
				aks_rep_itm_detail_code: '',
				aks_rep_itm_detail_consolidate_settlement: '',
				aks_rep_itm_detail_created_by: '',
				aks_rep_itm_detail_created_date: '',
				aks_rep_itm_detail_credit_limit: '',
				aks_rep_itm_detail_current_instalment: '',
				aks_rep_itm_detail_current_outstanding: '',
				aks_rep_itm_detail_deduction_amount: '',
				aks_rep_itm_detail_deleted_date: '',
				aks_rep_itm_detail_description: '',
				aks_rep_itm_detail_remain_month:'',
				aks_rep_itm_detail_end: '',
				aks_rep_itm_detail_id: '',
				aks_rep_itm_detail_new_instalment: '',
				aks_rep_itm_detail_parent_id: '',
				aks_rep_itm_detail_special_settlement: '',
				aks_rep_itm_detail_type: '',
				aks_rep_itm_detail_updated_by: '',
				aks_rep_itm_detail_updated_date: '',
			})
		},
		saveTable(){
			this.is_loading = true;
			Promise.all([
					this.saveAllAngkasaItems(this.tableData, this.current_credit_report_id, this.current_customer_id),
					this.deleteAngkasaItems(this.deleteIds)
			]).then(res=>{
				_gNotif.notifySuccess('<b>Angkasa Items</b> - Successfully Updated.');
				solutionEventBus.$emit('refresh-ctos')
				this.is_loading = false;
			}).catch(e => {
				this.is_loading = false
				_gNotif.errorFunction(e)
			});
    },
		deleteItem(trade_ref_id, index){
			if(!_gHlp.isEmpty(trade_ref_id)){
				this.deleteIds.push(trade_ref_id);
			}
			this.tableData.splice(index,1);
		},
		setConsolidate(index,item){
			if(item.aks_rep_itm_detail_is_consolidate){
				item['aks_rep_itm_detail_consolidate_settlement_prev'] = item.aks_rep_itm_detail_consolidate_settlement;
				item['aks_rep_itm_detail_new_instalment_prev'] = item.aks_rep_itm_detail_new_instalment;

				item.aks_rep_itm_detail_consolidate_settlement = item.aks_rep_itm_detail_current_outstanding;
				item.aks_rep_itm_detail_new_instalment = 0;
			}else{
				if(!_gHlp.isEmpty(item.aks_rep_itm_detail_consolidate_settlement_prev)){
					item.aks_rep_itm_detail_consolidate_settlement = item.aks_rep_itm_detail_consolidate_settlement_prev
				}
				if(!_gHlp.isEmpty(item.aks_rep_itm_detail_new_instalment_prev)){
					item.aks_rep_itm_detail_new_instalment = item.aks_rep_itm_detail_new_instalment_prev
				}
			}
			
			this.tableData[index] = item;
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = 'Summary';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
				} else {
					sums[index] = '';
				}
			});

			return sums;
		},
		formatCurrency(row, column, cellValue) {
			return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MYR' }).format(cellValue);
		},
		getRowClassName(row,index){
			if (!(row.aks_rep_itm_detail_end.indexOf("99") !== -1) && (row.aks_rep_itm_detail_remain_month == 0)) {
				return "d-none";
			}
			return '';
		}
	}
}
</script>